module.exports = __webpack_public_path__ + "8bde2ea5e0577bebf18f6c7eef966029.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/POS-2-03.png
// module id = 282
// module chunks = 0